export default "__VITE_ASSET__BLcvOhVX__"